import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarClassicEmbedRoute: InvariantJiraRoute = {
	name: 'software-calendar-classic-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
	query: ['date?'],
};
